import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=edb48bf2&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=edb48bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb48bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edb48bf2')) {
      api.createRecord('edb48bf2', component.options)
    } else {
      api.reload('edb48bf2', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=edb48bf2&scoped=true&", function () {
      api.rerender('edb48bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-86KHDcCh95T0h/JS/comp/DocBox.vue"
export default component.exports